import React from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import "@frameworks/web/stylesheets/components/Reports/RevampedReports/Generic/PANPassword.scss";
const PANPassword = (props) => {
    var _a;
    const device = DeviceContext();
    return (React.createElement("div", { className: (_a = props === null || props === void 0 ? void 0 : props.parentClass) !== null && _a !== void 0 ? _a : "" },
        React.createElement("div", { className: "pdf-pan" },
            React.createElement("div", { className: "note-heading" },
                React.createElement("i", { className: "edel-icon-attention-icon" })),
            React.createElement("div", { className: "message txt-grayish-blue" },
                React.createElement("span", { className: (device === null || device === void 0 ? void 0 : device.isDesktop) ? "DMSanN_16_400" : "DMSanN_14_400" },
                    "This ",
                    `${(props === null || props === void 0 ? void 0 : props.reportText) ? props === null || props === void 0 ? void 0 : props.reportText : "report "}`,
                    " is password protected. Enter your\u00A0"),
                React.createElement("span", { className: (device === null || device === void 0 ? void 0 : device.isDesktop) ? "DMSan_16_700" : "DMSan_14_700" }, "PAN in upper case as your password.")))));
};
export default PANPassword;
